/* eslint-disable no-unused-vars */
import React, { PureComponent } from 'react';
import Toggle from 'material-ui/Toggle';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Trans, withTranslation } from 'react-i18next';

import { objectToArray } from '../../../../../../../utils';

import { FlatButton } from '../../../../../../../app/components/buttons';
import FormFields from '../../../../../components/form';

import './styles.css';

class Edit extends React.Component {
  componentDidMount() {
    if (this.props.match && this.props.match.params.event) {
      this.props.getEventDetails();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.match &&
      JSON.stringify(this.props.match) !== JSON.stringify(prevProps.match)
    ) {
      this.props.getEventDetails();
    }
  }

  render() {
    const {
      pending,
      error,
      onSubmit,
      onRequestClose,
      onFieldChange,
      match,
      fields,
      fieldsData,
      role,
      t,
    } = this.props;

    const { isRecurringEvent } = fieldsData;

    return (
      <Dialog
        open={!!(match && match.params.event)}
        onClose={() => onRequestClose(role)}
        autoScrollBodyContent
        scroll="paper"
        maxWidth="lg"
      >
        <div className="user-events-modal-content">
          <div className="modal-heading">
            <DialogTitle>
              <Trans>Edit Event</Trans>
            </DialogTitle>
          </div>
          <div>
            <FormFields
              fields={fields}
              onFieldChange={onFieldChange}
              fieldsData={fieldsData}
              isRecurringEvent={isRecurringEvent}
            />
            <div style={{ padding: '10px 7px' }}>
              <div className="field-wrapper">
                <Toggle
                  onToggle={(v, b) => {}}
                  toggled={isRecurringEvent}
                  label={t('Recurring event')}
                  disabled={true}
                />
              </div>
            </div>
            <div className="submit-button-container">
              <FlatButton
                label={pending ? t('Saving...') : t('Save')}
                onClick={onSubmit}
                primary
                disabled={
                  pending ||
                  !fieldsData ||
                  !!objectToArray(fieldsData).find(
                    i =>
                      !i.value.isValid &&
                      i.id !== 'createdAt' &&
                      i.id !== 'memberbody' &&
                      i.id !== 'updatedAt' &&
                      i.id !== 'isRecurringEvent' &&
                      i.id !== 'recurringType' &&
                      i.id !== 'recurringValue',
                  )
                }
              />
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

Edit.propTypes = {
  error: PropTypes.string,
  pending: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  match: PropTypes.object,
  onRequestClose: PropTypes.func.isRequired,
  getEventDetails: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  fieldsData: PropTypes.object.isRequired,
  role: PropTypes.string,
  t: PropTypes.func.isRequired,
};

Edit.defaultProps = {
  error: null,
  fields: {},
  fieldsData: {},
  match: {},
  role: 'admin',
};

export default withTranslation()(Edit);
